import React from 'react'
import { Box, Flex } from '@chakra-ui/react'

import ChatClientInfoHeader from './header'
import ChatClientDetailsForms from './forms'
import ChatClientDetailsPhones from './phones'
import ChatClientDetails from './client-details'
import ChatClientDetailsPatients from './patients'
import ChatClientDetailsNotes from './notes'
import { ChatFieldsFragment } from '~graphql/generated/graphql'
import ChatClientDetailsUpcomingReminders from './upcoming-reminders'
import ChatClientDetailsNextAppointment from './appointments/next-appointment'
import ChatClientDetailsLastAppointment from './appointments/previous-appointment'

interface Props {
    chat: ChatFieldsFragment
    isOpen: boolean
    onClose: () => void
}

export default function ChatClientInfo({ chat, isOpen, onClose }: Props) {
    return (
        <Box
            flex={1}
            maxW="316px"
            minW="296px"
            h="full"
            transition="all 0.1s ease-out"
            overflow="hidden"
            display={{
                base: 'none',
                lg: isOpen ? 'block' : 'none',
            }}
        >
            <Flex
                h="full"
                w="full"
                bg="white"
                rounded="2xl"
                borderWidth={1}
                shadow="blue.lg"
                flexDir="column"
                borderColor="gray.200"
                transition="all 0.1s ease-out"
            >
                <ChatClientInfoHeader chat={chat} onClose={onClose} />
                <Box flex={1} overflowY="scroll">
                    <ChatClientDetails chat={chat} />
                    <Box borderTopWidth={1} borderColor="gray.100">
                        <ChatClientDetailsPhones chat={chat} />
                        <ChatClientDetailsPatients chat={chat} />
                        <ChatClientDetailsNotes chat={chat} />
                        <ChatClientDetailsUpcomingReminders chat={chat} />
                        <ChatClientDetailsNextAppointment chat={chat} />
                        <ChatClientDetailsLastAppointment chat={chat} />
                        <ChatClientDetailsForms chat={chat} />
                    </Box>
                </Box>
            </Flex>
        </Box>
    )
}
